import { Album as DownloadAlbum } from '@bpm-web-app/download-api-sdk';
import { MouseEventHandler } from 'react';
import { ThreeDotsSheetOptionsKeys } from '../../three-dots-sheet/three-dots-sheet.context';
import { AddedColumnOverlayMode } from '../supreme/track-list-supreme-helpers';
import { QuickActionsColumn } from './quick-actions-column';

type OpenThreeDotsHandler = (e: React.MouseEvent<HTMLButtonElement>, initialKey?: ThreeDotsSheetOptionsKeys) => void;

interface AddedColumnOverlayActionsProps {
    mode: AddedColumnOverlayMode;
    embedded?: boolean;
    openPlaylists: MouseEventHandler<HTMLButtonElement>;
    openThreeDots: OpenThreeDotsHandler;
    downloadAlbum?: DownloadAlbum;
    addDownloadTrackToCrate?: (mediaId: number) => void;
    onRemoveFromCrate: MouseEventHandler<HTMLButtonElement>;
    onOpenCrateThreeDots: MouseEventHandler<HTMLButtonElement>;
}

export function AddedColumnOverlayActions({
    mode,
    embedded,
    openPlaylists,
    openThreeDots,
    downloadAlbum,
    addDownloadTrackToCrate,
    onRemoveFromCrate,
    onOpenCrateThreeDots,
}: AddedColumnOverlayActionsProps) {
    if (mode === 'crate') {
        return (
            <QuickActionsColumn
                variant="crate"
                embedded={embedded}
                onRemoveFromCrate={onRemoveFromCrate}
                onOpenThreeDots={onOpenCrateThreeDots}
            />
        );
    }

    return (
        <QuickActionsColumn
            openPlaylists={openPlaylists}
            openThreeDots={openThreeDots}
            downloadAlbum={downloadAlbum}
            addDownloadTrackToCrate={addDownloadTrackToCrate}
            embedded={embedded}
        />
    );
}
